import { createAsyncAction } from "@dpdgroupuk/redux-action-creator";

import { authApi } from "../../apis";
import ActionTypes from "./actionTypes";

export const fetchUser = createAsyncAction(
  () => authApi.getMe().then((response = {}) => response.data),
  ActionTypes.FETCH_USER
);
